import { Property, Type } from '@dipscope/type-manager';
import { Position } from '../tilebase/Tile';
import { Topology } from '../tilebase/Topology';
import KTile, { Place, KPosition, Shape, KTilePos } from './KTile';

export type NbPlaces = {
  triangle: Place[];
  rhombus: Place[];
  hexa: Place[];
};
export interface KTileNbs {
  nbs: Map<KTilePos, { originalPos: KTilePos; nbTile: KTile }>;
}
@Type({
  discriminant: 'HexaTopology',
  injectable: true
})
export class HexaTopology {
  // nb place (triangle shape only) of place (any shape) on all side
  // group by places's positions
  nbPositions(openPlace: Place): Map<KTilePos, KPosition[]> {
    const places: Map<KTilePos, KPosition[]> = new Map();

    for (const openPosition of openPlace.positions) {
      const openPosKey = openPosition.toString();
      if (!places.has(openPosKey)) places.set(openPosKey, []);
      const { x, y, slot } = openPosition;
      if (slot === 0) {
        places
          .get(openPosKey)
          ?.push(new KPosition().init(x + 1, y - 1, 3), new KPosition().init(x, y, 1), new KPosition().init(x, y, 5));
      }
      if (slot === 1) {
        places
          .get(openPosKey)
          ?.push(new KPosition().init(x, y, 0), new KPosition().init(x + 1, y, 4), new KPosition().init(x, y, 2));
      }
      if (slot === 2) {
        places
          .get(openPosKey)
          ?.push(new KPosition().init(x, y, 1), new KPosition().init(x, y + 1, 5), new KPosition().init(x, y, 3));
      }
      if (slot === 3) {
        places
          .get(openPosKey)
          ?.push(new KPosition().init(x, y, 2), new KPosition().init(x - 1, y + 1, 0), new KPosition().init(x, y, 4));
      }
      if (slot === 4) {
        places
          .get(openPosKey)
          ?.push(new KPosition().init(x, y, 3), new KPosition().init(x - 1, y, 1), new KPosition().init(x, y, 5));
      }
      if (slot === 5) {
        places
          .get(openPosKey)
          ?.push(new KPosition().init(x, y, 0), new KPosition().init(x, y, 4), new KPosition().init(x, y - 1, 2));
      }
    }

    return places;
  }

  // all nb places (of all shape) of triangle position p
  nbPlacesAll(p: KPosition): Place[] {
    const places: Place[] = [];
    const { x, y, slot } = p;
    if (slot === 0) {
      places.push(
        new Place('triangle', [new KPosition().init(x + 1, y - 1, 3)]),
        new Place('triangle', [new KPosition().init(x, y, 1)]),
        new Place('triangle', [new KPosition().init(x, y, 5)])
      );
      places.push(
        new Place('rhombus', [new KPosition().init(x + 1, y - 1, 2), new KPosition().init(x + 1, y - 1, 3)]),
        new Place('rhombus', [new KPosition().init(x + 1, y - 1, 3), new KPosition().init(x + 1, y - 1, 4)]),
        new Place('rhombus', [new KPosition().init(x + 1, y, 4), new KPosition().init(x, y, 1)]),
        new Place('rhombus', [new KPosition().init(x, y, 1), new KPosition().init(x, y, 2)]),
        new Place('rhombus', [new KPosition().init(x, y, 4), new KPosition().init(x, y, 5)]),
        new Place('rhombus', [new KPosition().init(x, y - 1, 2), new KPosition().init(x, y, 5)])
      );
      places.push(
        new Place('hexa', [
          new KPosition().init(x + 1, y - 1, 0),
          new KPosition().init(x + 1, y - 1, 1),
          new KPosition().init(x + 1, y - 1, 2),
          new KPosition().init(x + 1, y - 1, 3),
          new KPosition().init(x + 1, y - 1, 4),
          new KPosition().init(x + 1, y - 1, 5)
        ]),
        new Place('hexa', [
          new KPosition().init(x, y, 1),
          new KPosition().init(x, y, 2),
          new KPosition().init(x + 1, y, 3),
          new KPosition().init(x + 1, y, 4),
          new KPosition().init(x, y + 1, 0),
          new KPosition().init(x, y + 1, 5)
        ]),
        new Place('hexa', [
          new KPosition().init(x, y, 4),
          new KPosition().init(x, y, 5),
          new KPosition().init(x - 1, y, 0),
          new KPosition().init(x - 1, y, 1),
          new KPosition().init(x, y - 1, 2),
          new KPosition().init(x, y - 1, 3)
        ])
      );
    }
    if (slot === 1) {
      places.push(
        new Place('triangle', [new KPosition().init(x, y, 0)]),
        new Place('triangle', [new KPosition().init(x + 1, y, 4)]),
        new Place('triangle', [new KPosition().init(x, y, 2)])
      );
      places.push(
        new Place('rhombus', [new KPosition().init(x + 1, y, 4), new KPosition().init(x + 1, y, 5)]),
        new Place('rhombus', [new KPosition().init(x + 1, y, 3), new KPosition().init(x + 1, y, 4)]),
        new Place('rhombus', [new KPosition().init(x, y, 2), new KPosition().init(x, y, 3)]),
        new Place('rhombus', [new KPosition().init(x, y, 0), new KPosition().init(x, y, 5)]),
        new Place('rhombus', [new KPosition().init(x, y, 0), new KPosition().init(x + 1, y - 1, 3)]),
        new Place('rhombus', [new KPosition().init(x, y, 2), new KPosition().init(x, y + 1, 5)])
      );
      places.push(
        new Place('hexa', [
          new KPosition().init(x + 1, y, 0),
          new KPosition().init(x + 1, y, 1),
          new KPosition().init(x + 1, y, 2),
          new KPosition().init(x + 1, y, 3),
          new KPosition().init(x + 1, y, 4),
          new KPosition().init(x + 1, y, 5)
        ]),
        new Place('hexa', [
          new KPosition().init(x - 1, y + 1, 0),
          new KPosition().init(x - 1, y + 1, 1),
          new KPosition().init(x, y, 2),
          new KPosition().init(x, y, 3),
          new KPosition().init(x, y + 1, 4),
          new KPosition().init(x, y + 1, 5)
        ]),
        new Place('hexa', [
          new KPosition().init(x, y, 0),
          new KPosition().init(x, y, 5),
          new KPosition().init(x, y - 1, 1),
          new KPosition().init(x, y - 1, 2),
          new KPosition().init(x + 1, y - 1, 3),
          new KPosition().init(x + 1, y - 1, 4)
        ])
      );
    }
    if (slot === 2) {
      places.push(
        new Place('triangle', [new KPosition().init(x, y, 1)]),
        new Place('triangle', [new KPosition().init(x, y + 1, 5)]),
        new Place('triangle', [new KPosition().init(x, y, 3)])
      );
      places.push(
        new Place('rhombus', [new KPosition().init(x, y, 0), new KPosition().init(x, y, 1)]),
        new Place('rhombus', [new KPosition().init(x, y, 1), new KPosition().init(x + 1, y, 4)]),
        new Place('rhombus', [new KPosition().init(x, y + 1, 0), new KPosition().init(x, y + 1, 5)]),
        new Place('rhombus', [new KPosition().init(x, y + 1, 4), new KPosition().init(x, y + 1, 5)]),
        new Place('rhombus', [new KPosition().init(x, y, 3), new KPosition().init(x, y, 4)]),
        new Place('rhombus', [new KPosition().init(x, y, 3), new KPosition().init(x - 1, y + 1, 0)])
      );
      places.push(
        new Place('hexa', [
          new KPosition().init(x, y, 0),
          new KPosition().init(x, y, 1),
          new KPosition().init(x + 1, y - 1, 2),
          new KPosition().init(x + 1, y - 1, 3),
          new KPosition().init(x + 1, y, 4),
          new KPosition().init(x + 1, y, 5)
        ]),
        new Place('hexa', [
          new KPosition().init(x, y + 1, 0),
          new KPosition().init(x, y + 1, 1),
          new KPosition().init(x, y + 1, 2),
          new KPosition().init(x, y + 1, 3),
          new KPosition().init(x, y + 1, 4),
          new KPosition().init(x, y + 1, 5)
        ]),
        new Place('hexa', [
          new KPosition().init(x - 1, y + 1, 0),
          new KPosition().init(x - 1, y, 1),
          new KPosition().init(x - 1, y, 2),
          new KPosition().init(x, y, 3),
          new KPosition().init(x, y, 4),
          new KPosition().init(x - 1, y + 1, 5)
        ])
      );
    }
    if (slot === 3) {
      places.push(
        new Place('triangle', [new KPosition().init(x, y, 2)]),
        new Place('triangle', [new KPosition().init(x - 1, y + 1, 0)]),
        new Place('triangle', [new KPosition().init(x, y, 4)])
      );
      places.push(
        new Place('rhombus', [new KPosition().init(x, y, 1), new KPosition().init(x, y, 2)]),
        new Place('rhombus', [new KPosition().init(x, y, 2), new KPosition().init(x, y + 1, 5)]),
        new Place('rhombus', [new KPosition().init(x - 1, y + 1, 0), new KPosition().init(x - 1, y + 1, 1)]),
        new Place('rhombus', [new KPosition().init(x - 1, y + 1, 0), new KPosition().init(x - 1, y + 1, 5)]),
        new Place('rhombus', [new KPosition().init(x, y, 4), new KPosition().init(x, y, 5)]),
        new Place('rhombus', [new KPosition().init(x, y, 4), new KPosition().init(x - 1, y, 1)])
      );
      places.push(
        new Place('hexa', [
          new KPosition().init(x, y, 1),
          new KPosition().init(x, y, 2),
          new KPosition().init(x + 1, y, 3),
          new KPosition().init(x + 1, y, 4),
          new KPosition().init(x, y + 1, 0),
          new KPosition().init(x, y + 1, 5)
        ]),
        new Place('hexa', [
          new KPosition().init(x - 1, y + 1, 0),
          new KPosition().init(x - 1, y + 1, 1),
          new KPosition().init(x - 1, y + 1, 2),
          new KPosition().init(x - 1, y + 1, 3),
          new KPosition().init(x - 1, y + 1, 4),
          new KPosition().init(x - 1, y + 1, 5)
        ]),
        new Place('hexa', [
          new KPosition().init(x, y, 4),
          new KPosition().init(x, y, 5),
          new KPosition().init(x - 1, y, 0),
          new KPosition().init(x - 1, y, 1),
          new KPosition().init(x, y - 1, 2),
          new KPosition().init(x, y - 1, 3)
        ])
      );
    }
    if (slot === 4) {
      places.push(
        new Place('triangle', [new KPosition().init(x, y, 3)]),
        new Place('triangle', [new KPosition().init(x - 1, y, 1)]),
        new Place('triangle', [new KPosition().init(x, y, 5)])
      );
      places.push(
        new Place('rhombus', [new KPosition().init(x, y, 0), new KPosition().init(x, y, 5)]),
        new Place('rhombus', [new KPosition().init(x, y, 5), new KPosition().init(x, y - 1, 2)]),
        new Place('rhombus', [new KPosition().init(x, y, 2), new KPosition().init(x, y, 3)]),
        new Place('rhombus', [new KPosition().init(x, y, 3), new KPosition().init(x - 1, y + 1, 0)]),
        new Place('rhombus', [new KPosition().init(x - 1, y, 0), new KPosition().init(x - 1, y, 1)]),
        new Place('rhombus', [new KPosition().init(x - 1, y, 1), new KPosition().init(x - 1, y, 2)])
      );
      places.push(
        new Place('hexa', [
          new KPosition().init(x - 1, y, 0),
          new KPosition().init(x - 1, y, 1),
          new KPosition().init(x - 1, y, 2),
          new KPosition().init(x - 1, y, 3),
          new KPosition().init(x - 1, y, 4),
          new KPosition().init(x - 1, y, 5)
        ]),
        new Place('hexa', [
          new KPosition().init(x - 1, y + 1, 0),
          new KPosition().init(x - 1, y + 1, 1),
          new KPosition().init(x, y, 2),
          new KPosition().init(x, y, 3),
          new KPosition().init(x, y + 1, 4),
          new KPosition().init(x, y + 1, 5)
        ]),
        new Place('hexa', [
          new KPosition().init(x, y, 0),
          new KPosition().init(x, y - 1, 1),
          new KPosition().init(x, y - 1, 2),
          new KPosition().init(x + 1, y - 1, 3),
          new KPosition().init(x + 1, y - 1, 4),
          new KPosition().init(x, y, 5)
        ])
      );
    }
    if (slot === 5) {
      places.push(
        new Place('triangle', [new KPosition().init(x, y, 0)]),
        new Place('triangle', [new KPosition().init(x, y, 4)]),
        new Place('triangle', [new KPosition().init(x, y - 1, 2)])
      );
      places.push(
        new Place('rhombus', [new KPosition().init(x, y, 0), new KPosition().init(x, y, 1)]),
        new Place('rhombus', [new KPosition().init(x, y, 0), new KPosition().init(x + 1, y - 1, 3)]),
        new Place('rhombus', [new KPosition().init(x, y - 1, 1), new KPosition().init(x, y - 1, 2)]),
        new Place('rhombus', [new KPosition().init(x, y - 1, 2), new KPosition().init(x, y - 1, 3)]),
        new Place('rhombus', [new KPosition().init(x, y, 3), new KPosition().init(x, y, 4)]),
        new Place('rhombus', [new KPosition().init(x, y, 4), new KPosition().init(x - 1, y, 1)])
      );
      places.push(
        new Place('hexa', [
          new KPosition().init(x, y - 1, 0),
          new KPosition().init(x, y - 1, 1),
          new KPosition().init(x, y - 1, 2),
          new KPosition().init(x, y - 1, 3),
          new KPosition().init(x, y - 1, 4),
          new KPosition().init(x, y - 1, 5)
        ]),
        new Place('hexa', [
          new KPosition().init(x, y, 0),
          new KPosition().init(x, y, 1),
          new KPosition().init(x + 1, y, 4),
          new KPosition().init(x + 1, y, 5),
          new KPosition().init(x + 1, y - 1, 2),
          new KPosition().init(x + 1, y - 1, 3)
        ]),
        new Place('hexa', [
          new KPosition().init(x, y, 3),
          new KPosition().init(x, y, 4),
          new KPosition().init(x - 1, y, 1),
          new KPosition().init(x - 1, y, 2),
          new KPosition().init(x - 1, y + 1, 0),
          new KPosition().init(x - 1, y + 1, 5)
        ])
      );
    }

    return places;
  }
}
